export const calculateDiscountPrice = (price, count = 1, period = 1, discount = 0) => {
    return (price * count * period * (100 - discount)) / 100;
};

export const calcDiscount = (price, count, period) =>
    ({
        monthly: price * count,
        "monthly-3": price * count * 3,
        "monthly-6": price * count * 6,
        annual: price * count * 12,
        "annual-2": price * count * 24,
        forever: price * count,
    }[period]);

export const calcPrice = (price, period, count, discount) =>
    ({
        monthly: calculateDiscountPrice(price, count, 1, discount),
        "monthly-3": calculateDiscountPrice(price, count, 3, discount),
        "monthly-6": calculateDiscountPrice(price, count, 6, discount),
        annual: calculateDiscountPrice(price, count, 12, discount),
        "annual-2": calculateDiscountPrice(price, count, 24, discount),
        forever: calculateDiscountPrice(price, count, 1, discount),
    }[period]);

export const getProductQuantity = (details, type) =>
    ({
        supsis: details?.agentCount || 1,
        whatsapp: details?.whatsappChannel || 1,
        "whatsapp-business": details?.whatsappChannel || 1,
        instagram: details?.instagramChannel || 1,
        messenger: details?.messengerChannel || 1,
        trendyol: details?.trendyolChannel || 1,
        "meta-lead": details?.metaLeadChannel || 1,
        telegram: details?.telegramChannel || 1,
        linkedin: details?.linkedinChannel || 1,
        webphone: details?.channelCount || 1,
        default: 1,
    }[type]);
